import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state: {
    EmailId: "",
    PortalUsersList: [],
    get_video_List: {},
    Current_user: {},
  },
  getters: {
    get_user_email(state) {
      return state.EmailId;
    },
    get_video_List(state) {
      return state.get_video_List;
    },
    get_current_user_details: (state) => {
      return state.Current_user;
    },
    get_portal_user_details: (state) => {
      return state.PortalUsersList;
    },
  },
  mutations: {
    SET_USEREMAIL(state, set_email) {
      state.EmailId = set_email;
    },
    SET_VIDEO_LIST(state, set_video_list) {
      state.get_video_List = set_video_list;
    },
    SET_CURRENT_USER(state, Current_user) {
      state.Current_user = Current_user;
    },
    SET_PORTAL_USER(state, PortalUsersList) {
      state.PortalUsersList = PortalUsersList;
    },
  },
  actions: {},
  modules: {},
  plugins: [createPersistedState()],
});
